/**
 * Lazy loader for @useparagon/connect library.
 *
 * Paragon SDK self-initializes and accesses localStorage on import,
 * which breaks tests in Node environment. This wrapper defers loading
 * until actually needed.
 *
 * Usage:
 *   import { loadParagon } from '@/utils/paragon-loader';
 *
 *   async function connectIntegration() {
 *     const paragon = await loadParagon();
 *     await paragon.authenticate(projectId, token);
 *   }
 */
import { createLazyModule } from './lazy';

export const paragonModule = createLazyModule(async () => {
  const { paragon } = await import('@useparagon/connect');
  return { paragon };
});

export const loadParagon = async () => {
  const { paragon } = await paragonModule.load();
  return paragon;
};

export const isParagonLoaded = paragonModule.isLoaded;
export const resetParagon = paragonModule.reset;
